import { render, staticRenderFns } from "./PendingExternalProductsTitle.vue?vue&type=template&id=91638636&scoped=true"
import script from "./PendingExternalProductsTitle.vue?vue&type=script&lang=js"
export * from "./PendingExternalProductsTitle.vue?vue&type=script&lang=js"
import style0 from "./PendingExternalProductsTitle.vue?vue&type=style&index=0&id=91638636&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91638636",
  null
  
)

export default component.exports